import { Button, Grid, Typography } from "@mui/material";
import Link from "next/link";

function CurrentOpening({
  jobs,
}: {
  jobs: {
    department: string;
    position: string;
    experience: string;
    link: string;
  }[];
}) {
  const openings: { role: string; link?: string }[] = [
    {
      role: "Graphic designer-Video Editor",
      link: "https://gromo-graphicdesigner.lovable.app",
    },
    { role: "Sr UI/UX Designer", link: "https://zyra-senioruiuxdesigner.lovable.app" },
    { role: "Sr Product Manager" },
    { role: "Marketing Intern", link: "https://gromo-marketingintern.lovable.app" },
  ];

  return (
    <>
      <Grid
        sx={{
          padding: { xs: "6% 4%", md: "4%" },
          backgroundColor: "#F4F7FF",
          margin: "50px auto 20px auto",
          display: { xs: "flex", md: "" },
          justifyContent: { xs: "center", md: "" },
          alignItems: { xs: "center", md: "" },
          flexDirection: { xs: "column", md: "" },
          maxWidth: "1440px",
        }}
      >
        <Grid
          sx={{
            width: "100%",
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 700,
              fontSize: "36px",
              lineHeight: { xs: "", md: "44px" },
              textAlign: "center",
              margin: "10px 0",
            }}
          >
            We’re hiring
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: { xs: "", md: "24px" },
              textAlign: "center",
              margin: { xs: "auto", md: "10px 0" },
              color: "#393F50",
              width: { xs: "100%", md: "100%" },
            }}
          >
            People are our greatest strength. Want to do the best work of your
            life ? Join our rocket ship
          </Typography>
        </Grid>

        <Grid
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr" },
            margin: { xs: "16px 24px", md: "20px auto" },
            width: "100%",
            padding: "1%",
          }}
        >
          <Grid>
            {openings.map((item, i) => {
              const button = (
                <Button
                  variant="contained"
                  disabled={!item.link}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#08AC17",
                    },
                    backgroundColor: "#08AC17",
                    color: "white",
                    padding: "8px 24px",
                    width: { xs: "80%", md: "fit-content" },
                    margin: { xs: "8px auto", md: "auto" },
                    display: { xs: "block" },
                    fontSize: { xs: "16px", md: "14px" },
                  }}
                >
                  View Opening
                </Button>
              );

              return (
                <Grid
                  key={i}
                  sx={{
                    padding: "2%",
                    width: { xs: "100%", md: "90%" },
                    margin: "16px auto",
                    display: { xs: "block", md: "grid" },
                    gridTemplateColumns: "8fr 4fr",
                    placeContent: "center",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                >
                  <Grid>
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        fontSize: "20px",
                        lineHeight: "32px",
                        color: "#001833",
                        padding: " 0 10px 0 20px",
                        margin: { xs: "8px 0" },
                      }}
                    >
                      {item.role}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: "14px", md: "16px" },
                        lineHeight: { xs: "20px" },
                        color: "#001833",
                        padding: " 0 10px 0 20px",
                        margin: { xs: "8px 0" },
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#9EA2AE",
                          fontWeight: 500,
                          margin: "12px 0",
                        }}
                      >
                        Location
                      </span>
                      <br /> Gurgaon
                    </Typography>
                  </Grid>

                  {item.link ? (
                    <Link href={item.link} target="_blank" rel="noopener noreferrer">
                      {button}
                    </Link>
                  ) : (
                    button
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CurrentOpening;
